import angular from 'angular';

export const loadModule = () =>
  angular
    .module('app')
    .controller('ApplyOnlineSentCtrl', function ApplyOnlineSentCtrl(
      $scope,
      $uibModalInstance,
    ) {
      $scope.cancel = () => {
        $uibModalInstance.dismiss('cancel');
      };
    });
